









































































import { defineComponent, ref } from '@nuxtjs/composition-api'
import { useHome } from '~/composables';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { PropType } from 'vue';
import { SliderType } from '~/types/solepro/PageBuilder';
import { SLIDER_CLASSES } from '~/utils/constants/solepro/pageBuilderCustomClasses';
import { Autoplay, Pagination } from 'swiper'
import { homeHeroLinkTrack } from '~/helpers/trackings/24orepro/home';

import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

// Import Swiper styles
import 'swiper/swiper-bundle.css'
import BrightcoveVideo from './BrightcoveVideo.vue';
SwiperCore.use([Pagination, Autoplay])

export default defineComponent({
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object as PropType<SliderType>,
            required: true
        }
    },
    components: {
        PageBuilderComponent,
        Swiper,
        SwiperSlide,
        BrightcoveVideo
        // VueSlickCarousel
    },
    setup(props, context) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        const { setHeroRendered, heroRendered } = useHome();
        const isAutoplay = content.autoplay == "true";
        const autoplaySpeed = isAutoplay ? parseInt(content.autoplaySpeed) : 0;
        const customClasses = content.cssClasses.map(el => SLIDER_CLASSES[el] ?? '').join(' ').trim();
        const swiperPagination = ref(null);
        const cardsContainer = ref(null);
        const swiperInitialized = ref(false)
        const swiperProps = {
            loop: false, // isAutoplay || content.is_infinite == 'true', //can't use swiper loop  because of a brightcove script behavior
            slidesPerView: 1,
            loopedSlides: 0,
            slideClass: "slide",
            spaceBetween: 0,
            shortSwipes: false, longSwipesRatio: 0.1, longSwipesMs: 100,
            autoplay: {
                enabled: isAutoplay,
                delay: autoplaySpeed,
                disableOnInteraction: false
            },
            pagination: true
        };
        const hasSlider = content.children.length>1;
        if(!hasSlider){
            setHeroRendered(true)
        }
        const touchStartPosition = ref()
        const touchEndPosition = ref()
        const reachEndTimer=ref()
        return {
            content,
            isAutoplay,
            heroRendered,
            setHeroRendered,
            autoplaySpeed: content.autoplay == "true" ? autoplaySpeed : null,
            customClasses,
            cardsContainer,
            swiperProps,
            swiperPagination,
            Swiper,
            hasSlider,
            swiperInitialized,
            touchStartPosition,
            touchEndPosition,
            reachEndTimer,
            isLoop: isAutoplay || content.is_infinite == 'true'

        }
    },
    methods: {
        async trackHeroLink(buttonText, content,link,linkTargetBlank) { 
            await homeHeroLinkTrack(buttonText, content)
            if(linkTargetBlank){
                window.open(link, '_blank').focus()
            }else{
                window.location.href = link;
            }
        },
        getBgImage(jsonString) {
            const images = JSON.parse(jsonString.replaceAll('\\', ''));
            return images.desktop_image
        },
        updateBulletTimer(swiper) {
            //const swiper = swiperEl.detail[0];
            const previousIndex = this.getPreviousRealIndex(swiper);
            const currentIndex = this.getRealIndex(swiper);
            const lastIndex = swiper.slides.length - 1;
            const isLoopToFirst = previousIndex === lastIndex && currentIndex === 0;
            const isLoopToLast = previousIndex === 0 && currentIndex === lastIndex;
            if (!swiper.pagination.bullets) return;
            if (swiper.pagination.bullets.length) {
                if (isLoopToFirst || isLoopToLast) {
                    swiper.pagination.bullets.forEach((bullet) => {
                        this.handleTimerBulletAnimation(bullet, isLoopToFirst ? false : true);
                    })
                }
                //this.addAnimation(swiper.pagination.bullets[currentIndex], swiper.params.autoplay.delay)
                swiper.pagination.bullets.forEach((bullet, index) => {
                    if (index == parseInt(currentIndex)) {
                        this.addAnimation(bullet, swiper.params.autoplay.delay)
                    } else if (index < parseInt(currentIndex)) {
                        this.handleTimerBulletAnimation(bullet, true)
                    } else {
                        this.handleTimerBulletAnimation(bullet, false)
                    }

                })

            }
        },
        handleTimerBulletAnimation(bullet, addClass) {
            if (addClass) {
                bullet.classList.add('prev');
            } else {
                bullet.classList.remove('prev');
            }
            bullet.offsetHeight;
            bullet.querySelector(".bullet-timer").style.animation = null;
        },

        addAnimation(bullet, delay) {
            const currentBulletTimer = bullet.querySelector(".bullet-timer");
            currentBulletTimer.style.animation = `progress ${delay}ms linear forwards`;
        },
        init(swiper) {
            swiper.$el[0].querySelector('.swiper-wrapper').classList.add('aspect-square');
            swiper.$el[0].querySelector('.swiper-wrapper').classList.add('md:aspect-[unset]');
            if (window.innerWidth <= 1024) {
                setTimeout(()=>{
                    const cardsContainer = (this.$refs.cardsContainer as HTMLElement)
                    cardsContainer.style.maxHeight = Array.from(cardsContainer.children)[0].getBoundingClientRect().height + 'px'
                },0)
            }
            
        },
        handleGoTo(swiper, index){
            swiper.slideTo(index+1)
        },
        playCurrentVideo(swiper){
            const video = swiper.slides[swiper.activeIndex].querySelector('video');
            if (video) {
                const source = video.children[0];
                if(source && source.tagName == 'SOURCE'){
                    source.src = source.getAttribute('data-src').replace('mp4:', '');
                    video.load();
                }
                video.play();
            }
        },
        afterInit(swiper) {
            this.swiperInitialized = true
            const bulletTimer = document.createElement('span');
            bulletTimer.classList.add('bullet-timer')
            swiper.pagination.bullets.forEach((el, index) => {
                el.classList.add('relative')
                el.classList.add('overflow-hidden')
                el.appendChild(bulletTimer.cloneNode())
            });
            Array.from(this.$el.querySelectorAll('.swiper-pagination-bullet')).forEach((bullet, index)=>{
                bullet.classList.add('cursor-pointer')
                bullet.addEventListener('click',()=>this.handleGoTo(swiper, index))
            })
             
            this.updateBulletTimer(swiper)
            
            setTimeout(() => {
                this.setHeroRendered(true);    
            }, 0);
            
            this.playCurrentVideo(swiper)
        },
        resize(swiper) {
            const cardsContainer = (this.$refs.cardsContainer as HTMLElement)
            const tallesCard = Array.from(cardsContainer.children).reduce((tallest: Element, slide: Element) => {
                return slide.getBoundingClientRect().height > tallest.getBoundingClientRect().height ? slide : tallest;
            }) as Element
            const boundingCurrentCard = cardsContainer.children[this.getRealIndex(swiper)].getBoundingClientRect()
            if (window.innerWidth >= 1024) cardsContainer.style.maxHeight = boundingCurrentCard.height + 'px';
            else {
                cardsContainer.style.maxHeight = tallesCard.getBoundingClientRect().height + 'px'
            }
        },
        slideChange(swiper) {
            const isAutoplay = this.content.autoplay == "true";
            const realIndex = this.getRealIndex(swiper);
            this.playCurrentVideo(swiper)
            const cardsContainer = this.$el.querySelector('.cards-container') as HTMLElement;
           // const prevCard = cardsContainer.children[prevIndex] as HTMLElement
            const currentCard = cardsContainer.children[realIndex] as HTMLElement
            Array.from(cardsContainer.children).forEach((prevCard: HTMLElement) => {
                prevCard.style.opacity = '0'
                prevCard.style.position = "absolute"
                prevCard.style.zIndex = "-1";
                const transitionContainerPrev = prevCard.querySelector(".transition-container") as HTMLElement
                transitionContainerPrev.style.transform = 'translateY(30%)'
                prevCard.setAttribute('aria-hidden', 'true');
            })
            const boundingCurrentCard = currentCard.getBoundingClientRect()
            const transitionContainer = currentCard.querySelector(".transition-container") as HTMLElement
            transitionContainer.style.transform = 'translateY(0%)'
            // currentCard.style.transform = 'translateY(0%)'
            currentCard.style.opacity = '1';
            currentCard.style.zIndex = "1";
            currentCard.setAttribute('aria-hidden', 'false');
            if (window.innerWidth <= 1024) cardsContainer.style.maxHeight = boundingCurrentCard.height + 'px';
            if (isAutoplay) {
                this.updateBulletTimer(swiper)
            }
        },
        getRealIndex(swiper) {
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-real-index') : 0;
        },
        getPreviousRealIndex(swiper) {
            const activeSlideIndexEl = swiper.$el[0].querySelector('.swiper-slide-active .real-index');
            if (swiper.realIndex > swiper.previousIndex) { // going next
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-prev-index') : 0;
            } else { //going backwards
                return activeSlideIndexEl ? activeSlideIndexEl.getAttribute('data-next-index') : 0;
            }
        },
        touchStart(swiper, event){
            this.touchStartPosition = event.clientX;
        },
        touchEnd(swiper, event){
            const realMove = Math.abs(this.touchStartPosition - event.clientX) > 15;
            if(!realMove) return;
            if(this.touchStartPosition > event.clientX && swiper.realIndex == swiper.slides.length-1){
                swiper.slideTo(0)
            }else if(this.touchStartPosition < event.clientX && swiper.realIndex==0){
                swiper.slideTo(swiper.slides.length-1)
            }
        },
        reachEnd(swiper){
            this.reachEndTimer = this.isLoop ? setTimeout(()=>{
                if(this.reachEndTimer){
                     swiper.slideTo(0)
                    }
            },this.autoplaySpeed) : null;
        },
        slideChangeTransitionEnd(swiper){
            if(this.isLoop && this.reachEndTimer && swiper.realIndex!==swiper.slides.length-1) {
            this.reachEndTimer = null;    
            clearTimeout(this.reachEndTimer)
            }
        }
    },
    beforeDestroy(){
        Array.from(this.$el.querySelectorAll('.swiper-pagination-bullet')).forEach((bullet, index)=>{
            /** removing all event listeners */
            var new_element = bullet.cloneNode(true);
            bullet.parentNode.replaceChild(new_element, bullet);
            })
    }
})
